<nav class="navbar bg-body-tertiary">
    <div class="container d-flex justify-content-between align-items-center py-2">
        <a class="navbar-brand" href="#">
            <img src="./../../../../assets/images/brand/astro.png" alt="Logo" style="height:50px;">
        </a>
        <div class="welcome-text">
            <h4 class="mb-0">WELCOME TO BE POSITIVE</h4>
        </div>
    </div>

</nav>

<div class="page">
    <div class="page-main">
        <div class="sticky">
            <div class="horizontal-main hor-menu clearfix">
                <div class="horizontal-mainwrapper container clearfix">
                    <nav class="horizontalMenu clearfix">
                        <ul class="horizontalMenu-list p-4">
                            <li class="p-1">&nbsp;</li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <!-- HORIZONTAL-MENU END -->

        <!-- CONTAINER -->
        <!-- CONTAINER -->


        <div class="container content-area relative">



            <!-- ROW-1 OPEN -->
            <form [formGroup]="addAstrologerForm" (submit)="onAddAstrologerSubmit()">
                <div class="row">
                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div class="card">
                            <div class="card-header welcome-text">
                                <h4 class="astrologer-heading  ">
                                    🔮 Sign Up as an Astrologer
                                </h4>


                            </div>
                            <div class="card-body">
                                <div class="accordion" id="accordionExample">
                                    <!-- Personal Information Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                                Personal Information
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- Full Name -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Full Name</mat-label>
                                                            <input type="text" matInput formControlName="name"
                                                                [errorStateMatcher]="matcher"
                                                                placeholder="Enter Your Name" />
                                                            @if(f.name.invalid && (f.name.dirty || f.name.touched)) {
                                                            <mat-error>Name is Required</mat-error>
                                                            }
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Gender -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Gender</mat-label>
                                                            <mat-select formControlName="gender">
                                                                <mat-option value="male">Male</mat-option>
                                                                <mat-option value="female">Female</mat-option>
                                                                <mat-option value="other">Other</mat-option>
                                                            </mat-select>
                                                            <mat-error
                                                                *ngIf="f.gender.invalid && (f.gender.dirty || f.gender.touched)">
                                                                Gender is required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Date of Birth</mat-label>
                                                            <input matInput [matDatepicker]="picker"
                                                                formControlName="dob"
                                                                placeholder="Select Date of Birth">
                                                            <mat-datepicker-toggle matIconSuffix
                                                                [for]="picker"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker></mat-datepicker>

                                                            <mat-error
                                                                *ngIf="f.dob.invalid && (f.dob.dirty || f.dob.touched)">
                                                                Date of Birth is required
                                                            </mat-error>
                                                        </mat-form-field>

                                                    </div>


                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Profile Image</mat-label>
                                                            <input matInput
                                                                [value]="selectedFileName || 'No file chosen'"
                                                                placeholder="Profile Image" readonly
                                                                (click)="fileInput.click()" />

                                                            <input #fileInput type="file" accept="image/*"
                                                                (change)="onProfileImageUpload($event)" hidden />

                                                            <button matSuffix mat-icon-button
                                                                (click)="fileInput.click()" type="button">
                                                                <mat-icon>upload</mat-icon>
                                                            </button>
                                                            <mat-error
                                                                *ngIf="f.profile_image.invalid && (f.profile_image.dirty || f.profile_image.touched)">
                                                                Profile image is required
                                                            </mat-error>
                                                            <mat-error *ngIf="profileError !== ''">
                                                                {{ profileError }}
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Contact Information Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                aria-expanded="false" aria-controls="collapseTwo">
                                                Contact Information
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- Email -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Email</mat-label>
                                                            <input type="email" matInput formControlName="email"
                                                                placeholder="Email address" />
                                                            @if(f.email.invalid && (f.email.dirty || f.email.touched)) {
                                                            <mat-error>Email is required</mat-error>
                                                            }
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Password -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Password</mat-label>
                                                            <input type="password" matInput formControlName="password"
                                                                placeholder="Password" />
                                                            @if(f.password.invalid && (f.password.dirty ||
                                                            f.password.touched)) {
                                                            <mat-error>Password is required</mat-error>
                                                            }
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Contact Number -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Contact Number</mat-label>
                                                            <input type="number" matInput formControlName="phone"
                                                                placeholder="Phone number" />
                                                            <mat-error
                                                                *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)">
                                                                Valid Phone Number Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Alternate Number -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Alternate Number</mat-label>
                                                            <input type="number" matInput
                                                                formControlName="alternate_num"
                                                                placeholder="Alternate Number" />
                                                            <mat-error
                                                                *ngIf="f.alternate_num.invalid && (f.alternate_num.dirty || f.alternate_num.touched)">
                                                                Valid Phone Number Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Address Information Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree">
                                                Address Information
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- Address -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Address</mat-label>
                                                            <input matInput formControlName="complete_address"
                                                                placeholder="Complete Address" />
                                                            <mat-error
                                                                *ngIf="f.complete_address.invalid && (f.complete_address.dirty || f.complete_address.touched)">
                                                                Address is required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- City -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>City</mat-label>
                                                            <input matInput formControlName="city" placeholder="City" />
                                                            <mat-error
                                                                *ngIf="f.city.invalid && (f.city.dirty || f.city.touched)">
                                                                City is required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- State -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>State</mat-label>
                                                            <input matInput formControlName="state"
                                                                placeholder="State" />
                                                            <mat-error
                                                                *ngIf="f.state.invalid && (f.state.dirty || f.state.touched)">
                                                                State is required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Country -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Country</mat-label>
                                                            <input matInput formControlName="country"
                                                                placeholder="Country" />
                                                            <mat-error
                                                                *ngIf="f.country.invalid && (f.country.dirty || f.country.touched)">
                                                                Country is required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Pin Code -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Pin Code</mat-label>
                                                            <input matInput type="text" formControlName="pincode"
                                                                placeholder="Pin Code" />
                                                            <mat-error
                                                                *ngIf="f.pincode.invalid && (f.pincode.dirty || f.pincode.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Professional Information Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                aria-expanded="false" aria-controls="collapseFour">
                                                Professional Information
                                            </button>
                                        </h2>
                                        <div id="collapseFour" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- Skills -->
                                                    <div class="col-lg-3 col-md-12">

                                                        <ng-select [items]="skillsData" appearance="outline" bindLabel="skillname"
                                                            bindValue="_id" [multiple]="true"
                                                            placeholder="Select Skills" formControlName="skill"
                                                            class="w-100">
                                                        </ng-select>


                                                    </div>


                                                    <!-- Language Known -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <ng-select placeholder="Select Languages" appearance="outline" [multiple]="true"
                                                            formControlName="lang" class="w-100" [items]="languageData"
                                                            bindLabel="name" bindValue="_id">
                                                        </ng-select>
                                                    </div>

                                                    <!-- Consultant Type -->
                                                    <div class="col-lg-3 col-md-12 mt-3 mt-md-0">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Consultant Type</mat-label>
                                                            <input type="text" matInput
                                                                formControlName="consultant_type"
                                                                placeholder="Consultant Type" readonly />
                                                            <mat-error
                                                                *ngIf="f.consultant_type.invalid && (f.consultant_type.dirty || f.consultant_type.touched)">
                                                                Consultant Type is required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>


                                                    <!-- Experience -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Experience</mat-label>
                                                            <input type="number" matInput formControlName="experience"
                                                                placeholder="Experience eg. 1, 10, 15" />
                                                            <mat-error
                                                                *ngIf="f.experience.invalid && (f.experience.dirty || f.experience.touched)">
                                                                Required. Only Numbers Allowed
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Working With Others -->

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Financial Information Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                                aria-expanded="false" aria-controls="collapseFive">
                                                Financial Information
                                            </button>
                                        </h2>
                                        <div id="collapseFive" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- Bank Account Number -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Bank Account Number</mat-label>
                                                            <input matInput type="text"
                                                                formControlName="bank_account_num"
                                                                placeholder="Bank Account Number" />
                                                            <mat-error
                                                                *ngIf="f.bank_account_num.invalid && (f.bank_account_num.dirty || f.bank_account_num.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Account Type -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Account Type</mat-label>
                                                            <mat-select formControlName="account_type">
                                                                <mat-option value="" disabled>Select Account
                                                                    Type</mat-option>
                                                                <mat-option value="savings">Saving</mat-option>
                                                                <mat-option value="current">Current</mat-option>
                                                            </mat-select>
                                                            <mat-error
                                                                *ngIf="f.account_type.invalid && (f.account_type.dirty || f.account_type.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Account Holder Name -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Account Holder Name</mat-label>
                                                            <input matInput type="text"
                                                                formControlName="account_holder_name"
                                                                placeholder="Account Holder Name" />
                                                            <mat-error
                                                                *ngIf="f.account_holder_name.invalid && (f.account_holder_name.dirty || f.account_holder_name.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- IFSC -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>IFSC</mat-label>
                                                            <input matInput type="text" formControlName="ifsc"
                                                                placeholder="IFSC" />
                                                            <mat-error
                                                                *ngIf="f.ifsc.invalid && (f.ifsc.dirty || f.ifsc.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Identification Documents Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseSix"
                                                aria-expanded="false" aria-controls="collapseSix">
                                                Identification Documents
                                            </button>
                                        </h2>
                                        <div id="collapseSix" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- PAN Number -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>PAN Number</mat-label>
                                                            <input matInput type="text" formControlName="pan_number"
                                                                placeholder="Pan Number" />
                                                            <mat-error
                                                                *ngIf="f.pan_number.invalid && (f.pan_number.dirty || f.pan_number.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Aadhar Number -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Aadhar Number</mat-label>
                                                            <input matInput type="text" formControlName="addhar_number"
                                                                placeholder="Aadhar Number" />
                                                            <mat-error
                                                                *ngIf="f.addhar_number.invalid && (f.addhar_number.dirty || f.addhar_number.touched)">
                                                                Required. Enter Valid Aadhar Card Number
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Proof Image -->
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Proof Image</mat-label>
                                                            <input matInput
                                                                [value]="selectedProofFileName || 'No file chosen'"
                                                                placeholder="Proof Image" readonly
                                                                (click)="proofFileInput.click()" />
                                                            <input #proofFileInput type="file" accept="image/*"
                                                                (change)="onProofImageUpload($event)" hidden />
                                                            <button matSuffix mat-icon-button
                                                                (click)="proofFileInput.click()" type="button">
                                                                <mat-icon>upload</mat-icon>
                                                            </button>
                                                            <mat-error
                                                                *ngIf="f.proof_image.invalid && (f.proof_image.dirty || f.proof_image.touched)">
                                                                Proof image is required
                                                            </mat-error>
                                                            <mat-error *ngIf="proofError !== ''">
                                                                {{ proofError }}
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-lg-3 col-md-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Working With Others</mat-label>
                                                            <mat-select formControlName="working_with_other">
                                                                <mat-option value="yes">Yes</mat-option>
                                                                <mat-option value="no">No</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Biography Section -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseSeven"
                                                aria-expanded="false" aria-controls="collapseSeven">
                                                Biography
                                            </button>
                                        </h2>
                                        <div id="collapseSeven" class="accordion-collapse collapse show">
                                            <div class="accordion-body">
                                                <div class="row">
                                                    <!-- Short Bio -->
                                                    <div class="col-lg-6 col-sm-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>Short Bio</mat-label>
                                                            <textarea matInput formControlName="short_bio"
                                                                placeholder="Description" rows="3"></textarea>
                                                            <mat-error
                                                                *ngIf="f.short_bio.invalid && (f.short_bio.dirty || f.short_bio.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- Long Bio -->
                                                    <div class="col-lg-6 col-sm-12">
                                                        <mat-form-field appearance="outline" class="w-100">
                                                            <mat-label>About Me</mat-label>
                                                            <textarea matInput rows="3" formControlName="long_bio"
                                                                placeholder="My bio........."></textarea>
                                                            <mat-error
                                                                *ngIf="f.long_bio.invalid && (f.long_bio.dirty || f.long_bio.touched)">
                                                                Required
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-footer">
                                <button type="submit" class="btn btn-success mt-1 btn-block"
                                    [disabled]="!addAstrologerForm.valid">Submit</button><br />
                                <span class="text-danger" *ngIf="!addAstrologerForm.valid">Fields with * are
                                    required</span>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <!-- ROW-1 CLOSED -->


        </div>



    </div>

    <!-- SIDE-BAR -->
    <!-- <app-sidebar></app-sidebar> -->
    <!-- SIDE-BAR CLOSED -->

    <!-- FOOTER -->
    <app-footer></app-footer>
    <!-- FOOTER END -->
</div>